module.exports = __webpack_public_path__ + "static/media/davidsons.65a14826.png";